import { supabase } from "../lib/supabase";
import type { RapportPaymentHold } from "../../../../types";

/**
 * Betaalblokkade-status per rapport ("rapport na betaling"): the
 * get_rapport_payment_holds RPC reports whether a rapport is held back by an
 * unpaid factuur, plus the payment details of that factuur (when verzonden)
 * so the portal can offer a direct payment path.
 */
export function useRapportPaymentHolds() {
  async function fetchRapportPaymentHolds(rapportIds: string[]): Promise<Map<string, RapportPaymentHold>> {
    const holds = new Map<string, RapportPaymentHold>();
    const ids = Array.from(new Set(rapportIds.filter(Boolean)));
    if (ids.length === 0) return holds;

    // The RPC caps at 200 ids per call.
    for (let offset = 0; offset < ids.length; offset += 200) {
      const chunk = ids.slice(offset, offset + 200);
      const { data, error } = await supabase.rpc("get_rapport_payment_holds", { p_rapport_ids: chunk });
      if (error) throw error;

      for (const row of (data || []) as RapportPaymentHold[]) {
        holds.set(row.rapport_id, row);
      }
    }

    return holds;
  }

  async function fetchRapportPaymentHold(rapportId: string): Promise<RapportPaymentHold | null> {
    const holds = await fetchRapportPaymentHolds([rapportId]);
    return holds.get(rapportId) ?? null;
  }

  return { fetchRapportPaymentHolds, fetchRapportPaymentHold };
}
